// extracted by mini-css-extract-plugin
export default {"UserBriefDetails":"styles_UserBriefDetails__6LyG0","MenuBarEnd":"styles_MenuBarEnd__1oDRa","MenuBarStart":"styles_MenuBarStart__QJjOf"};